import { render, staticRenderFns } from "./AllCoupons.vue?vue&type=template&id=742f0f34&"
import script from "./AllCoupons.vue?vue&type=script&lang=js&"
export * from "./AllCoupons.vue?vue&type=script&lang=js&"
import style0 from "./AllCoupons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports